<div class="c-slotcardReward">
  <div class="c-slotcardReward__container">
    <div
      class="c-slotcardReward__background"
      theming
      themingGroup="slotcard"
      themingAsset="start-background"
      [themingOverride]="slotcardRewardModalData?.properties?.assets">
      <div class="c-slotcardReward__info">
        <div
          class="c-slotcardReward__icon"
          theming
          themingGroup="slotcard"
          themingAsset="logo"
          [themingOverride]="slotcardRewardModalData?.properties?.assets">
          @if (slotcardRewardModalData.properties.extraRewardPercentage != 0) {
            <div class="c-slotcardReward__discount">
              <span class="text percent">{{ slotcardRewardModalData.properties.extraRewardPercentage }}&#37;</span>
              <span class="text extra">{{ 'home.live-ops.slotcard.extra' | translate }}</span>
            </div>
          }
        </div>
        <div class="c-slotcardReward__text">
          <span class="text title">{{ 'home.live-ops.slotcard.modal-reward.title' | translate }}</span>

          <slotcom-display [classes]="['c-display--slotcard', 'c-display--slotcard--reward']">
            <div
              displayIcon
              displayIconPos="left"
              class="c-display--coin"></div>
            <span data-testid="slotcard-reward-credits">{{
              slotcardRewardModalData.reward.credits | number: '1.0-0' : ('common.culture' | translate)
            }}</span>
          </slotcom-display>

          @if (slotcardRewardModalData.properties.extraRewardPercentage != 0) {
            <span class="text extra">
              &#43;{{ slotcardRewardModalData.properties.extraRewardPercentage }}&#37;&nbsp;{{
                'home.live-ops.slotcard.extra' | translate
              }}
              {{ 'home.live-ops.slotcard.modal-reward.subtitle' | translate }}
            </span>
          }

          <slotcom-button
            class="c-button--pink"
            data-testid="slotcard-close-reward-button"
            (safeClick)="closeModal()"
            audioType="reward"
            [ngClass]="slotcardRewardModalData.properties.extraRewardPercentage == 0 ? 'margin' : ''">
            {{
              slotcardRewardModalData.properties.buttonText[lang]
                ? slotcardRewardModalData.properties.buttonText[lang]
                : ('home.buttons.great' | translate | uppercase)
            }}
          </slotcom-button>
        </div>
      </div>
    </div>
  </div>
</div>
